<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-overlay :value="$store.state.isloading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-title class="headline">Selecione o Trimestre</v-card-title>
          <v-col cols="12" md="12">
            <v-select v-model="trimestre" item-value="idTrimestre" item-text="descricao" :items="trimestres" filled
              color="blue-grey lighten-2" label="Trimestre" return-object></v-select>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="fecharPopUp()">Cancelar</v-btn>
            <v-btn color="green darken-1" text :disabled="!trimestre" @click="carregarRelatorio()">Avançar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from '../../../plugins/axios'
import impressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    processando: false,
    dialog: true,
    relatorio: [],
    html: ``,
    titulo: 'O Boletim',
    trimestre: null,
    trimestres: [
      { idTrimestre: 1, descricao: '1º Trimestre', relatorio: 'bt' },
      { idTrimestre: 2, descricao: '2º Trimestre', relatorio: 'bt' },
      { idTrimestre: 3, descricao: '3º Trimestre', relatorio: 'b3t' },
      { idTrimestre: 4, descricao: 'Todos', relatorio: 'bg' }
    ],
    arrayTrimestreFirst: [],
    arrayTrimestreSecond: [],
    arrayTrimestreThird: [],
    listaAlunos: [],
    configuracoesReport: ls.get('configuracoesReport')
  }),
  created() {
    this.CarregaBoletim();
  },
  methods: {
    fecharPopUp() {
      this.$emit('fecharComponente', false);
    },

    async carregarRelatorio() {
      try {
        this.relatorio = await axios
          .get('/obterRelatorioByDescricao/' + this.trimestre.relatorio)
          .then(res => res.data)
        if (this.relatorio.length) {
          this.comporBoletim()
        } else {
          Swal.fire('Informação', 'Boletim não configurado!', 'info')
        }
      } catch (error) {
        this.fecharPopUp()
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o relatório' })
      }
    },

    async CarregaBoletim() {
      this.$store.state.isloading = true;
      try {
        this.listaAlunos = await axios
          .post('/gerarBoletim', this.$store.state.objAluno)
          .then(res => res.data)
        this.$store.state.isloading = false
        if (this.listaAlunos.length > 0) { this.listaAlunos = this.listaAlunos[0] }
        this.filterBoletimAlunos(this.listaAlunos)
      } catch (error) {
        this.fecharPopUp()
        this.$store.state.isloading = false
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      } finally {
        this.$store.state.isloading = false;
      }
    },
    async filterBoletimAlunos(arrayAllPauta) {
      for (let i = 0; i < arrayAllPauta.length; i++) {
        this.arrayTrimestreFirst.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t1_mac, p1: arrayAllPauta[i].t1_nota1, p2: arrayAllPauta[i].t1_nota2, md: arrayAllPauta[i].t1_md })
        this.arrayTrimestreSecond.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t2_mac, p1: arrayAllPauta[i].t2_nota1, p2: arrayAllPauta[i].t2_nota2, md: arrayAllPauta[i].t2_md })
        this.arrayTrimestreThird.push({ disciplina: arrayAllPauta[i].disciplina, mac: arrayAllPauta[i].t3_mac, p1: arrayAllPauta[i].t3_nota1, md: arrayAllPauta[i].t3_md })
      }
    },

    async comporBoletim() {
      try {
        let boletimConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'nome_escola')
        let boletimAluno = []

        if (this.trimestre.idTrimestre > 0 && this.trimestre.idTrimestre < 5) {
          this.$store.state.isloading = true
          // eslint-disable-next-line no-unused-vars
          // let classe = this.anoAcademicos.filter(t => t.idAno_academico === this.$store.state.objAluno.idAno_Academico)
          // Boletim do Aluno em função do Trimestre
          if (this.trimestre.idTrimestre === 1) boletimAluno = this.arrayTrimestreFirst
          else
            if (this.trimestre.idTrimestre === 2) boletimAluno = this.arrayTrimestreSecond
            else
              if (this.trimestre.idTrimestre === 3) boletimAluno = this.arrayTrimestreThird
              else
                if (this.trimestre.idTrimestre === 4) {
                  boletimAluno = this.listaAlunos
                }
          this.html = this.relatorio[0].documento
          let documentoiter = this.relatorio[0].documentoiteracao1
          this.html = this.html.replace(/{{instituicaodescricao}}/g, (boletimConfiguracoes[0].valor).toUpperCase())
          this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
          this.html = this.html.replace(/{{logotipo}}/g, ls.get('logotipo'))
          this.html = this.html.replace(/{{nomeAluno}}/g, this.$store.state.objAluno.nome.toUpperCase())
          this.html = this.html.replace(/{{matricula}}/g, this.$store.state.objAluno.idMAtricula)
          this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
          this.html = this.html.replace(/{{curso}}/g, this.$store.state.objAluno.curso)
          this.html = this.html.replace(/{{turma}}/g, this.$store.state.objAluno.turma)
          this.html = this.html.replace(/{{classe}}/g, this.$store.state.objAluno.classe.substring(0, 3))
          this.html = this.html.replace(/{{periodo}}/g, this.$store.state.objAluno.periodo)
          this.html = this.html.replace(/{{dataacual}}/g, this.correntDate())
          this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
          this.html = this.html.replace(/{{rascunho}}/g, '')
          let dados = ``
          if (this.trimestre.idTrimestre >= 1 && this.trimestre.idTrimestre < 3) {
            boletimAluno.forEach(element => {
              let iteracao = documentoiter
              iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
              iteracao = iteracao.replace(/{{mac}}/g, this.isNull(element.mac))
              iteracao = iteracao.replace(/{{p1}}/g, this.isNull(element.p1))
              iteracao = iteracao.replace(/{{p2}}/g, this.isNull(element.p2))
              iteracao = iteracao.replace(/{{md}}/g, this.isNull(element.md))
              dados += iteracao
            })

            this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
            this.html = this.html.replace(/{{dados}}/g, dados)
            let option = { 'format': 'A5' }
            impressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
          } else
            if (this.trimestre.idTrimestre === 3) {


              boletimAluno.forEach(element => {
                let iteracao = documentoiter
                iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
                iteracao = iteracao.replace(/{{mac}}/g, this.isNull(element.mac))
                iteracao = iteracao.replace(/{{p1}}/g, this.isNull(element.p1))
                iteracao = iteracao.replace(/{{md}}/g, this.isNull(element.md))
                dados += iteracao
              })

              this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
              this.html = this.html.replace(/{{dados}}/g, dados)
              let option = { 'format': 'A5' }
              impressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
            } else
              if (this.trimestre.idTrimestre === 4) {
                boletimAluno.forEach(element => {
                  let iteracao = documentoiter
                  iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
                  iteracao = iteracao.replace(/{{t1_mac}}/g, this.isNull(element.t1_mac))
                  iteracao = iteracao.replace(/{{t1_nota1}}/g, this.isNull(element.t1_nota1))
                  iteracao = iteracao.replace(/{{t1_nota2}}/g, this.isNull(element.t1_nota2))
                  iteracao = iteracao.replace(/{{t1_md}}/g, this.isNull(element.t1_md))
                  iteracao = iteracao.replace(/{{t2_mac}}/g, this.isNull(element.t2_mac))
                  iteracao = iteracao.replace(/{{t2_nota1}}/g, this.isNull(element.t2_nota1))
                  iteracao = iteracao.replace(/{{t2_nota2}}/g, this.isNull(element.t2_nota2))
                  iteracao = iteracao.replace(/{{t2_md}}/g, this.isNull(element.t2_md))
                  iteracao = iteracao.replace(/{{t3_mac}}/g, this.isNull(element.t3_mac))
                  iteracao = iteracao.replace(/{{t3_nota1}}/g, this.isNull(element.t3_nota1))
                  iteracao = iteracao.replace(/{{t3_md}}/g, this.isNull(element.t3_md))
                  iteracao = iteracao.replace(/{{mfd}}/g, this.isNull(element.mfd))
                  iteracao = iteracao.replace(/{{exame}}/g, this.isNull(element.exame))
                  iteracao = iteracao.replace(/{{recurso}}/g, this.isNull(element.recurso))

                  iteracao = iteracao.replace(/{{mf_cor}}/g, this.isNull(element.mf_cor))
                  iteracao = iteracao.replace(/{{mf}}/g, this.isNull(element.mf))
                  dados += iteracao
                })
                this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
                this.html = this.html.replace(/{{dados}}/g, dados)
                let option = { 'format': 'A4' }
                impressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
              }
        }
      } catch (error) {
        this.$store.state.isloading = false
        this.fecharComponente()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      } finally {
        this.fecharPopUp()
      }
    },
    correntDate() {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return d.getDate().toString() + ' de ' + month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    zebraPauta(i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    isNull(nota) {
      if (nota) { return nota } else return ''
    },
    fecharComponente() {
      this.$store.state.showDialogGuia.boletim = false
      this.$store.state.isloading = false
      this.$emit('fecharComponente', false);
    }
  }
}

</script>
